module.exports = __webpack_public_path__ + "img/avatar1.705fd4a9.png";